import React from "react";
import logo from "../../../lywo-self-service/src/assets/images/LYWOLogoSmall.svg";
import avatar from "../../../lywo-self-service/src/assets/images/achiever.svg";
import { useSelector } from "react-redux";
import { BASE_URL } from "../Api/ApiConfig";

const labelStyle = {
  minWidth: '120px',
  fontSize: 'var(--font-size-base)'
  // fontWeight: 'bold'
};

const rowStyle = {
  display: 'flex',
  gap: '20px',
  fontSize: 'var(--font-size-base)',
  // marginBottom: '10px',
  fontFamily: 'Calibri, sans-serif',
  alignItems: 'flex-start'
};

export default function JobDatas({ componentRef }) {
  const formData = useSelector((state) => state.form);

  console.log(formData.behaviorsDataApi?.selectedByUser);

  return (

    <div ref={componentRef} className="col-md-12"  >
      <div className="print-header">
        <div className="d-flex justify-content-between align-items-center">
          <div >
            <h1 style={{ fontSize: 'var(--font-size-h4)', fontFamily: 'Calibri' }}>{formData?.jobTitle}</h1>
            <h4 className="mt-1" style={{ fontSize: 'var(--font-size-base)', color: 'grey', fontFamily: 'Calibri' }}>{formData?.companyName}</h4>
          </div>
          <img
            src={BASE_URL + formData?.companyLogo}
            width={55}
            height={55}
            onError={(e) => (e.target.src = logo)}
          />
        </div>
      </div>
      <div className="print-content">
        <div className="d-flex justify-content-end" >

        </div>


        <div className="mt-4" style={{ fontSize: 'var(--font-size-base)', fontFamily: 'Calibri' }}>
          <h3 style={{ fontSize: 'var(--font-size-h4)', fontFamily: 'Calibri' }}>Brief Job Description :</h3>
          <p style={{ fontSize: 'var(--font-size-base)', fontFamily: 'Calibri' }}>
            {formData?.finalSelectedJobDescription}
          </p>
        </div>

        <div className="mt-4">
          <h3 style={{ fontSize: 'var(--font-size-h4)', fontFamily: 'Calibri' }}>Job Details :</h3>
          <div style={rowStyle}>
            <span style={labelStyle}>Industry</span>
            <span>{formData?.industry}</span>
          </div>

          <div style={rowStyle}>
            <span style={labelStyle}>Location</span>
            <span>{formData?.location}</span>
          </div>

          <div style={rowStyle}>
            <span style={labelStyle}>Compensation</span>
            <span>{formData?.salary}</span>
          </div>

          <div style={rowStyle}>
            <span style={labelStyle}>Type</span>
            <span>{formData?.jobType}</span>
          </div>

          <div style={rowStyle}>
            <span style={labelStyle}>Qualification</span>
            <span>{formData?.minEducationQualification}</span>
          </div>

        </div>

        <div class="mt-4">
          <h3 style={{ fontSize: 'var(--font-size-h4)', fontFamily: 'Calibri' }}>Job Descriptors (Key Words) Skills Required :</h3>
          <p style={{ fontSize: 'var(--font-size-base)', fontFamily: 'Calibri' }}>
            {formData.finalKeywordsForUser?.length > 0 &&
              formData?.finalKeywordsForUser?.map((keywords, index) => {
                return `${keywords}  ${index + 1 != formData?.finalKeywordsForUser?.length
                  ? ", "
                  : "."
                  }`;
              })}
          </p>
        </div>

        <div class="mt-4">
          <h3 style={{ fontSize: 'var(--font-size-h4)', fontFamily: 'Calibri' }}>Technical Skill Required :</h3>
          <p style={{ fontSize: 'var(--font-size-base)', fontFamily: 'Calibri' }}>
            {formData?.generatedSkillsArray?.map((group, index) => {
              return group?.recommended_skills?.map((skill, indx) => {
                return `${skill} ${indx != group?.recommended_skills?.length &&
                  index + 1 != group.length
                  ? ", "
                  : "."
                  }`;
              });
            })}
          </p>
        </div>

        <div class=" mt-4">
          <h3 style={{ fontSize: 'var(--font-size-h4)', fontFamily: 'Calibri' }} >
            Roles & Responsibilities
          </h3>
          <div >
            {formData?.finalSelectedResponsibilities?.length > 0 &&
              formData?.finalSelectedResponsibilities?.map((group, index) => {
                return (
                  <div >
                    <h3 style={{ fontSize: 'var(--font-size-base)', fontFamily: 'Calibri' }}>
                      {" "}
                      {group?.responsibilites_group || group?.groupTitle}
                    </h3>
                    <ol style={{ paddingLeft: '20px', fontSize: 'var(--font-size-base)', fontFamily: 'Calibri' }}>
                      {formData?.isView
                        ? group?.responsibilities?.map((item, idx) => (
                          <li key={idx}>
                            {item?.responsibilityText
                              ? item?.responsibilityText
                              : item}
                          </li>
                        ))
                        : group?.responsibilities
                          ? group?.responsibilities?.map((item, idx) => (
                            <li key={idx}>
                              {item?.responsibilityText
                                ? item?.responsibilityText
                                : item}
                            </li>
                          ))
                          : group?.responsibilites?.map((item, idx) => (
                            <li key={idx}>
                              {item?.responsibilityText
                                ? item?.responsibilityText
                                : item}
                            </li>
                          ))}
                    </ol>
                  </div>
                );
              })}
          </div>

        </div>
      </div>
      <div className="custom-footer"></div>
      <div className="print-footer">
        <span className="page-number"></span>
      </div>
      {/* <div className="candListBox">
        <div
          style={{
            marginLeft: "16px",
            marginRight: "16px",
            marginBottom: "44px",
          }}
        >
          {" "}
          <h1 class="job-title" style={{ fontSize: "var(--font-size-h1)", marginTop: "16px" }}>
            {formData?.finalJobDetails?.job_title ||
              formData?.finalJobDetails?.jobTitle}
            <div
              style={{
                display: "flex",
                justifyContent: "end",
                position: "relative",
                bottom: "28px",
              }}
            >
              {" "}
              <img
                src={BASE_URL + formData?.companyLogo}
                width={55}
                height={55}
                onError={(e) => (e.target.src = logo)}
              />
            </div>
          </h1>
          <div class="company-section">
            <h3 class="section-heading">{formData?.companyName}</h3>
            <p>{formData?.companyDescription}</p>
          </div>
          <div class="description-section">
            <h3 class="section-heading">Job Description</h3>
            <p>{formData.finalSelectedJobDescription}</p>
          </div>
          <div class="details-section">
            <h3 class="section-heading">Job Details :</h3>
            <ul>
              <li>
                <strong>Industry:</strong> {formData?.industry}
              </li>
              <li>
                <strong>Department:</strong> {formData?.department}
              </li>
              <li>
                <strong>Role:</strong> {formData?.department}
              </li>
              <li>
                <strong>Location:</strong> {formData?.location}
              </li>
              <li>
                <strong>Compensation:</strong> {formData?.salary}
              </li>
              <li>
                <strong>Experience:</strong> {formData?.experience}
              </li>
              <li>
                <strong>Employment Type:</strong> {formData?.jobType}
              </li>
              <li>
                <strong>Qualification:</strong>{" "}
                {formData?.minEducationQualification}
              </li>
            </ul>
          </div>
          <div class="keywords-section">
            <h3 class="section-heading">Keywords Defining the Job :</h3>
            <p>
              {formData.finalKeywordsForUser?.length > 0 &&
                formData?.finalKeywordsForUser?.map((keywords, index) => {
                  return `${keywords}  ${index + 1 != formData?.finalKeywordsForUser?.length
                    ? ", "
                    : "."
                    }`;
                })}
            </p>
          </div>
          <div class="keywords-section">
            <h3 class="section-heading">Skills Required for the Job :</h3>
            <p>
              {formData?.generatedSkillsArray?.map((group, index) => {
                return group?.recommended_skills?.map((skill, indx) => {
                  return `${skill} ${indx != group?.recommended_skills?.length &&
                    index + 1 != group.length
                    ? ", "
                    : "."
                    }`;
                });
              })}
            </p>
          </div>
          <div class="keywords-section">
            <h3 class="section-heading">Selected Behavior’s for the Job :</h3>
            <p>
              {formData.behaviorsDataApi?.selectedByUser?.map(
                (bevihour, index) => {
                  return `${bevihour.title} ${index + 1 != 4 ? ", " : ""}`;
                }
              )}
            </p>
          </div>
          <div class="keywords-section">
            <h3 class="section-heading">Ideal Personalities for the Job :</h3>
            <div
              class="card row"
              style={{ display: "flex", flexDirection: "row" }}
            >
              <div
                class="card-header col-md-2 col-sm-2"
                style={{
                  borderBottom: "0px",
                  display: "flex",
                  flexDirection: "column",
                }}
              >
                <h3 class="section-heading">Leader</h3>

                <img src={avatar} width={100} height={100} />
              </div>
              <div class="card-body col-md-10 col-sm-10">
                <p>
                  Leaders are practical, innovative, self-reliant, and ambitious
                  individuals that are always pushing to make things better.
                  They are friendly, charming, and enthusiastic in casual
                  circumstances but tend to be direct, forthright, and assertive
                  in formal setups. They like taking responsibility and taking
                  credit for both wins and losses, as long as they have control
                  of the results. They do not shy away from taking command when
                  needed and may be impatient with the inefficiencies of others.
                  They are sensitive to the needs of the team. They find a
                  balance between personal ambitions and group goals. They are
                  very clear thinkers, make good decisions and promote harmony
                  in the team.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="candListBox">
        <div
          style={{
            marginLeft: "16px",
            marginRight: "16px",
            marginBottom: "44px",
            marginTop: "16px",
          }}
        >
          {" "}
          <h3 class="section-heading mb-4" style={{ fontSize: "var(--font-size-h2)" }}>
            Roles & Responsibilities
          </h3>
          <div style={{ paddingLeft: "20px" }}>
            {formData?.finalSelectedResponsibilities?.length > 0 &&
              formData?.finalSelectedResponsibilities?.map((group, index) => {
                return (
                  <div class="details-section">
                    <h3 class="section-heading">
                      {" "}
                      {group?.responsibilites_group || group?.groupTitle}
                    </h3>
                    <ul>
                      {formData?.isView
                        ? group?.responsibilities?.map((item, idx) => (
                          <li key={idx}>
                            {item?.responsibilityText
                              ? item?.responsibilityText
                              : item}
                          </li>
                        ))
                        : group?.responsibilities
                          ? group?.responsibilities?.map((item, idx) => (
                            <li key={idx}>
                              {item?.responsibilityText
                                ? item?.responsibilityText
                                : item}
                            </li>
                          ))
                          : group?.responsibilites?.map((item, idx) => (
                            <li key={idx}>
                              {item?.responsibilityText
                                ? item?.responsibilityText
                                : item}
                            </li>
                          ))}
                    </ul>
                  </div>
                );
              })}
          </div>
        </div>
      </div> */}

    </div >
  );
}
